import React, { useEffect, useState, lazy } from 'react';
export const CTAButton = ({
  children,
  href = '#pricing',
  className = '',
  variant = 'primary'
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  variant?: 'primary' | 'outline';
}) => {
  const handleClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq && href.includes('checkout')) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'Vitality 360 Printable Care Kit',
        content_category: 'Health',
        currency: 'USD',
        value: 27
      });
    }
  };
  return <a href={href} onClick={handleClick} className={`inline-flex items-center justify-center px-8 py-4 rounded-lg font-bold uppercase transition-all duration-300 text-center cta-shadow cta-animated ${variant === 'primary' ? 'bg-familia-cyan text-familia-bg hover:bg-familia-coral/90' : 'border-2 border-familia-cyan text-familia-cyan hover:bg-familia-cyan/10'} ${className}`} data-id="element-170" data-mp="kejihkahe077">
      {children}
    </a>;
};
export const Countdown = ({
  className = ''
}: {
  className?: string;
}) => {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 15,
    s: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return {
          h: 0,
          m: 15,
          s: 0
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (n: number) => n.toString().padStart(2, '0');
  return <div className={`flex justify-center items-start gap-2 sm:gap-4 font-mono text-2xl sm:text-4xl md:text-6xl font-bold text-familia-cyan w-full ${className}`} data-id="element-171" data-mp="27wqdiah8ptv7">
      <div className="flex flex-col items-center" data-id="element-172" data-mp="1t6dnlicubaeb">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-173" data-mp="1y6ryr99qn0gk">
          [{format(timeLeft.h)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-174" data-mp="1o8voejomk9ji">
          hours
        </span>
      </div>
      <div className="pt-2 sm:pt-4" data-id="element-175" data-mp="2by6jbkjan9pq">:</div>
      <div className="flex flex-col items-center" data-id="element-176" data-mp="2c0j7wgjk4ibr">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-177" data-mp="2gxsulofkafvw">
          [{format(timeLeft.m)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-178" data-mp="2777we23svddi">
          minutes
        </span>
      </div>
      <div className="pt-2 sm:pt-4" data-id="element-179" data-mp="2uvr7sqi5c69t">:</div>
      <div className="flex flex-col items-center" data-id="element-180" data-mp="2zo0sns4emg58">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-181" data-mp="2zpln7hqpxz33">
          [{format(timeLeft.s)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-182" data-mp="j8xcsvn9b6kj">
          seconds
        </span>
      </div>
    </div>;
};
export const PriceCard = () => {
  const items = ['Module 1: Sharp Mind Workbook (150+ cognitive activities)', 'Module 2: Move with Confidence (Routines and fall prevention)', 'Module 3: Care Support Guide (Everyday senior care support notes)', 'Module 4: Vitality 360 Health Tracker (Health logs 2026)', 'Module 5: The Empowered Caregiver Guide (Burnout prevention & organization)', 'VIP Module: 150+ at-home activities (3 adaptation levels)', 'Bonus 1: Vital Nutrition 60+ (Recipes and weekly meal plan)', 'Bonus 2: Family Connection Kit (Reminiscence cards and family activities)', 'Bonus 3: Safe Home Checklist (Room-by-room printable checklist)', 'Large print throughout all materials', 'Clear illustrations for each activity', 'Printable trackers and logs', 'Ready-to-print PDF format', '240+ pages of printable content'];
  return <div className="bg-familia-section border-2 border-familia-gold rounded-2xl p-6 sm:p-10 shadow-[0_0_30px_-12px_rgba(242,181,68,0.5)] sm:shadow-[0_0_50px_-12px_rgba(242,181,68,0.4)] max-w-2xl mx-auto relative overflow-hidden" data-id="element-183" data-mp="2pzafot4jinxs">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-familia-gold text-familia-bg font-bold text-xs py-1 px-4 rounded-b-lg uppercase" data-id="element-184" data-mp="2zy9qah8v8tnf">
        Special Offer Price
      </div>
      <div className="text-center mt-4 mb-8" data-id="element-185" data-mp="38pa2f9cwrqy1">
        <h3 className="text-2xl font-display font-bold mb-1" data-id="element-186" data-mp="38qk2u578hb7u">Vitality 360™</h3>
        <p className="text-familia-gray text-sm uppercase tracking-widest" data-id="element-187" data-mp="3dnjxljymurjn">
          Complete Digital Kit
        </p>
      </div>
      <div className="flex items-center gap-4 mb-8 bg-familia-card/60 p-4 rounded-xl border border-white/5" data-id="element-188" data-mp="3ilv7tvsub42e">
        <img src="https://cdn.magicpatterns.com/uploads/wD6XHHXqEzi2b4vbyPnFv3/hf_20260528_015615_d7bdc0e4-f184-4423-868f-2fe77bd4c3a9-removebg-preview.png" alt="Vitality 360 Printable Care Kit" width="96" height="96" loading="lazy" className="w-24 h-24 object-contain" data-id="element-189" data-mp="3nkolppc1gx33" />
        <div className="flex flex-col items-start" data-id="element-190" data-mp="x388h4udxh6f">
          <span className="text-familia-red line-through text-lg mb-1" data-id="element-191" data-mp="x4j76q8z3yqo">
            $97 USD
          </span>
          <span className="text-familia-cyan text-4xl font-bold" data-id="element-192" data-mp="1us1kmedkxp10">$27 USD</span>
        </div>
      </div>
      <div className="bg-[#F0F7FF] border border-[#00A1FF] rounded-xl p-4 mb-6 text-left" data-id="element-193" data-mp="1l0dx2ok58s4t">
        <h4 className="text-[#001E3C] font-bold text-sm mb-1 flex items-center gap-2" data-id="element-194" data-mp="1ky16jn0bl9g5">
          🌎 INTERNATIONAL PAYMENT
        </h4>
        <p className="text-[#003A70] text-xs leading-relaxed" data-id="element-195" data-mp="2dgycycpf27gl">
          <strong data-id="element-196" data-mp="2dij9u8z7e2hm">The product price is $27 USD.</strong> During checkout, the
          amount will be automatically converted to your local currency
          according to your country, payment provider and available payment
          method.{' '}
          <strong data-id="element-197" data-mp="bqheroldc1qa">
            You will be able to review the final amount before confirming your
            payment.
          </strong>{' '}
          Purchase securely from anywhere in the world and receive instant
          digital access by email.
        </p>
      </div>
      <CTAButton href="https://vitality-360-the-complete-senior-care-system.impultienda.ar/checkout" className="w-full text-lg py-5 mb-4" data-id="element-198" data-mp="3k6t03ogfgzqv">
        GET INSTANT ACCESS TO VITALITY 360™
      </CTAButton>
      <div className="mb-6 text-center" data-id="element-199" data-mp="3aa6f8zo3q8ou">
        <div className="flex justify-center items-center gap-3 mb-2 opacity-80 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-200" data-mp="3ab930yq4nv0j">
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-blue-800 border border-gray-200" data-id="element-201" data-mp="18h9sifktxhow">
            VISA
          </span>
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-red-600 border border-gray-200" data-id="element-202" data-mp="1des6ikdpen3r">
            MASTERCARD
          </span>
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-blue-500 border border-gray-200" data-id="element-203" data-mp="2t0vhsen8srkv">
            AMEX
          </span>
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-purple-700 border border-gray-200" data-id="element-204" data-mp="37qjlfmiwc2br">
            DISCOVER
          </span>
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-orange-600 border border-gray-200" data-id="element-205" data-mp="3go3l4r141qk9">
            PAYPAL
          </span>
        </div>
        <p className="text-familia-gray text-[10px] leading-tight" data-id="element-206" data-mp="3qo48qp60isu9">
          🔒 Secure encrypted checkout. <br data-id="element-207" data-mp="3lnyfj4k3gya2" />
          Instant digital access in less than 5 minutes.
        </p>
      </div>
      <div className="flex flex-wrap justify-center gap-4 text-[10px] sm:text-xs text-familia-gray mb-8" data-id="element-208" data-mp="1w91mr1g69sw3">
        <span data-id="element-209" data-mp="1rb8iwf2cdayz">🔒 Secure payment</span>
        <span data-id="element-210" data-mp="1rc1kl1mg1aa9">⚡ Instant access</span>
        <span data-id="element-211" data-mp="15hay8gf92x2x">🛡️ 60-day guarantee</span>
        <span data-id="element-212" data-mp="15g9k232xtugz">🌍 Worldwide</span>
      </div>
      <div className="space-y-3 border-t border-white/10 pt-8" data-id="element-213" data-mp="15fgn1tts6jc1">
        {items.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-214" data-mp="1ae1eb3r21soc" data-mpi={i}>
            <span className="text-familia-green text-lg" data-id="element-215" data-mp="1f8fgbp082y1z">✅</span>
            <span className="text-sm sm:text-base font-medium" data-id="element-216" data-mp="1k6p7loitteib">{item}</span>
          </div>)}
      </div>
      <p className="text-center text-familia-gray text-xs mt-8" data-id="element-217" data-mp="mj8hsq0rq8gq">
        One-time payment · No subscription · Instant digital access · Lifetime
        access · Printable resources
      </p>
    </div>;
};